import { moment } from "@msuite/utils/date";
import { Fragment } from "react";
import { useCurrentPlan } from "@/hooks/use-current-plan";
import { CommandPlanCrew } from "./command-plan-crew";

export function CommandPlan() {
	/** Hooks */
	const { plans, date } = useCurrentPlan();

	/** Render */
	return (
		<div
			className="w-full h-full overflow-x-auto overflow-y-hidden"
			style={{ columns: 4, columnFill: "auto" }}
		>
			{plans.map((plan) => (
				<Fragment key={plan.id}>
					<div className="card mx-2 h-stack justify-between">
						<p className="heading">
							{plan.organizationName} - {moment(date).dateFormat()}
						</p>
						{plan.publishedAt && (
							<p>
								{moment(plan.publishedAt).longFormat()} by {plan.publishedByName}
							</p>
						)}
					</div>
					{plan.crews.map((crew) => (
						<CommandPlanCrew
							key={crew.crewId}
							crew={crew}
						/>
					))}
				</Fragment>
			))}
		</div>
	);
}
